/**
 * The initial value of Symbol.toPrimitive is the well-known symbol @@toPrimitive
 * https://tc39.es/ecma262/#sec-symbol.toprimitive
 */
export const symbolToPrimitive = () => Symbol("Symbol.toPrimitive");
